import script from "./comp_lista_alojamientos.vue?vue&type=script&setup=true&lang=js"
export * from "./comp_lista_alojamientos.vue?vue&type=script&setup=true&lang=js"

import "./comp_lista_alojamientos.vue?vue&type=style&index=0&id=7f41c6b8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f41c6b8"]])

export default __exports__